import { render, staticRenderFns } from "./DowntimeReasons.vue?vue&type=template&id=241c9486&scoped=true&"
import script from "./DowntimeReasons.vue?vue&type=script&lang=js&"
export * from "./DowntimeReasons.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeReasons.vue?vue&type=style&index=0&id=241c9486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c9486",
  null
  
)

export default component.exports